<template>
  <div class="certificados-declaracoes-container">
    <breadcrumb :items="breadcrumbItems" />

    <div class="header-menu-secao">
      <h2 class="titulo-pagina">Meus Certificados e Declarações</h2>
      <p class="subtitulo-pagina">
        Acesse e faça o download de seus certificados e declarações de
        participação em atividades de extensão.
      </p>
    </div>

    <!-- Seção de Certificados -->
    <div class="secao-documentos">
      <button
        class="botao-dropdown"
        @click="certificadosIsAtivo = !certificadosIsAtivo"
        :class="{ ativo: certificadosIsAtivo }"
      >
        <div class="botao-dropdown-esquerda">
          <svg
            class="secao-icon"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              fill="currentColor"
              d="M12 2C7.58 2 4 5.58 4 10c0 2.29.97 4.36 2.52 5.82L5 22l7-2 7 2-1.52-6.18C19.03 14.36 20 12.29 20 10c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
            />
          </svg>
          <h3>Certificados</h3>
        </div>
        <svg
          class="chevron-icon"
          :class="{ rotated: certificadosIsAtivo }"
          viewBox="0 0 24 24"
          width="24"
          height="24"
        >
          <path
            fill="currentColor"
            d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
          />
        </svg>
      </button>

      <div
        v-show="certificadosIsAtivo"
        class="secao-conteudo"
      >
        <div class="ordenacao-e-filtros">
          <div class="filtros">
            <span class="filtros-label">Filtros:</span>

            <div class="filtros-botoes">
              <div class="btn-group">
                <button
                  class="btn-filtro-dropdown dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Ano
                </button>
                <ul class="dropdown-menu">
                  <li
                    v-for="ano in anoCertificados"
                    :key="ano"
                  >
                    <button
                      class="dropdown-item"
                      @click="filtroCertificados = ano"
                    >
                      {{ ano }}
                    </button>
                  </li>
                </ul>
              </div>

              <div class="btn-group">
                <button
                  class="btn-filtro-dropdown dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Ação / Atividade
                </button>
                <ul class="dropdown-menu">
                  <li
                    v-for="acao in acaoCertificados"
                    :key="acao"
                  >
                    <button
                      class="dropdown-item"
                      @click="filtroCertificados = acao"
                    >
                      {{ acao }}
                    </button>
                  </li>
                </ul>
              </div>

              <button
                v-if="filtroCertificados"
                @click="filtroCertificados = ''"
                class="limpar-filtros"
              >
                Limpar filtro
              </button>
            </div>

            <span
              v-if="filtroCertificados"
              class="filtro-ativo-badge"
            >
              {{ filtroCertificados }}
              <span
                class="remover-filtro"
                @click="filtroCertificados = ''"
                >&times;</span
              >
            </span>
          </div>

          <div class="ordenacoes">
            <span class="ordenacao-label">Ordenar por:</span>
            <div class="btn-group">
              <button
                class="btn-filtro-dropdown dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{ ordenacaoCertificados }}
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li
                  v-for="ordenacao in ordenacoes"
                  :key="ordenacao"
                >
                  <button
                    class="dropdown-item"
                    @click="ordenacaoCertificados = ordenacao"
                  >
                    {{ ordenacao }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          class="lista-documentos"
          v-if="certificadosFiltrados.length > 0"
        >
          <div
            class="card-documento"
            v-for="certificado in certificadosFiltrados"
            :key="certificado.titulo"
          >
            <div class="card-documento-esquerda">
              <div class="documento-icon-container">
                <svg
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path
                    fill="currentColor"
                    d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4M12,18c-2.67,0-8,1.34-8,4v2h16v-2c0-2.66-5.33-4-8-4Z"
                  />
                </svg>
              </div>
              <div class="documento-info">
                <h4 class="documento-titulo">{{ certificado.titulo }}</h4>
                <div class="documento-detalhes">
                  <span
                    class="documento-acao-tag"
                    :title="certificado.acao"
                    >{{ certificado.acao }}</span
                  >
                  <span class="documento-divisor">•</span>
                  <span class="documento-data"
                    >Emitido em:
                    {{ formatarData(certificado.dataEmissao) }}</span
                  >
                </div>
              </div>
            </div>
            <div class="card-documento-direita">
              <a
                class="btn-download-documento"
                href=""
                download=""
              >
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  class="icon-baixar"
                >
                  <path
                    fill="currentColor"
                    d="M5,20H19V18H5V20M19,9H15V3H9V9H5L12,16L19,9Z"
                  />
                </svg>
                <span>Baixar PDF</span>
              </a>
            </div>
          </div>
        </div>

        <div
          class="sem-documentos"
          v-else
        >
          <svg
            viewBox="0 0 24 24"
            width="48"
            height="48"
            class="sem-doc-icon"
          >
            <path
              fill="currentColor"
              d="M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z"
            />
          </svg>
          <p>Nenhum certificado encontrado para os filtros selecionados.</p>
        </div>
      </div>
    </div>

    <!-- Seção de Declarações -->
    <div class="secao-documentos">
      <button
        class="botao-dropdown"
        @click="declaracoesIsAtivo = !declaracoesIsAtivo"
        :class="{ ativo: declaracoesIsAtivo }"
      >
        <div class="botao-dropdown-esquerda">
          <svg
            class="secao-icon"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              fill="currentColor"
              d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M16,18H8V16H16V18M16,14H8V12H16V14M13,9V3.5L18.5,9H13Z"
            />
          </svg>
          <h3>Declarações</h3>
        </div>
        <svg
          class="chevron-icon"
          :class="{ rotated: declaracoesIsAtivo }"
          viewBox="0 0 24 24"
          width="24"
          height="24"
        >
          <path
            fill="currentColor"
            d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
          />
        </svg>
      </button>

      <div
        v-show="declaracoesIsAtivo"
        class="secao-conteudo"
      >
        <div class="ordenacao-e-filtros">
          <div class="filtros">
            <span class="filtros-label">Filtros:</span>

            <div class="filtros-botoes">
              <div class="btn-group">
                <button
                  class="btn-filtro-dropdown dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Ano
                </button>
                <ul class="dropdown-menu">
                  <li
                    v-for="ano in anoDeclaracoes"
                    :key="ano"
                  >
                    <button
                      class="dropdown-item"
                      @click="filtroDeclaracoes = ano"
                    >
                      {{ ano }}
                    </button>
                  </li>
                </ul>
              </div>

              <div class="btn-group">
                <button
                  class="btn-filtro-dropdown dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Ação / Atividade
                </button>
                <ul class="dropdown-menu">
                  <li
                    v-for="acao in acaoDeclaracoes"
                    :key="acao"
                  >
                    <button
                      class="dropdown-item"
                      @click="filtroDeclaracoes = acao"
                    >
                      {{ acao }}
                    </button>
                  </li>
                </ul>
              </div>

              <button
                v-if="filtroDeclaracoes"
                @click="filtroDeclaracoes = ''"
                class="limpar-filtros"
              >
                Limpar filtro
              </button>
            </div>

            <span
              v-if="filtroDeclaracoes"
              class="filtro-ativo-badge"
            >
              {{ filtroDeclaracoes }}
              <span
                class="remover-filtro"
                @click="filtroDeclaracoes = ''"
                >&times;</span
              >
            </span>
          </div>

          <div class="ordenacoes">
            <span class="ordenacao-label">Ordenar por:</span>
            <div class="btn-group">
              <button
                class="btn-filtro-dropdown dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{ ordenacaoDeclaracoes }}
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li
                  v-for="ordenacao in ordenacoes"
                  :key="ordenacao"
                >
                  <button
                    class="dropdown-item"
                    @click="ordenacaoDeclaracoes = ordenacao"
                  >
                    {{ ordenacao }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          class="lista-documentos"
          v-if="declaracoesFiltradas.length > 0"
        >
          <div
            class="card-documento"
            v-for="declaracao in declaracoesFiltradas"
            :key="declaracao.filename"
          >
            <div class="card-documento-esquerda">
              <div class="documento-icon-container">
                <svg
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path
                    fill="currentColor"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M16,18H8V16H16V18M16,14H8V12H16V14M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </div>
              <div class="documento-info">
                <h4 class="documento-titulo">{{ declaracao.titulo }}</h4>
                <div class="documento-detalhes">
                  <span
                    class="documento-acao-tag"
                    :title="declaracao.acao"
                    >{{ declaracao.acao }}</span
                  >
                  <span class="documento-divisor">•</span>
                  <span class="documento-data"
                    >Emitido em: {{ declaracao.dataEmissaoFormatada }}</span
                  >
                </div>
              </div>
            </div>
            <div class="card-documento-direita">
              <button
                class="btn-download-documento"
                @click="baixarArquivoCertificado(declaracao)"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  class="icon-baixar"
                >
                  <path
                    fill="currentColor"
                    d="M5,20H19V18H5V20M19,9H15V3H9V9H5L12,16L19,9Z"
                  />
                </svg>
                <span>Baixar PDF</span>
              </button>
            </div>
          </div>
        </div>

        <div
          class="sem-documentos"
          v-else
        >
          <svg
            viewBox="0 0 24 24"
            width="48"
            height="48"
            class="sem-doc-icon"
          >
            <path
              fill="currentColor"
              d="M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z"
            />
          </svg>
          <p>Nenhuma declaração encontrada para os filtros selecionados.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, onMounted, reactive, ref } from "vue";
import { formatarData } from "@/utils/FormatarEntradas";
import certificadoService from "@/service/certificadoService";
import JSZip from "jszip";
import Breadcrumb from "@/components/common/Breadcrumb.vue";

var certificadosIsAtivo = ref(true);
var declaracoesIsAtivo = ref(true);

var filtroCertificados = ref("");
var filtroDeclaracoes = ref("");

var ordenacaoCertificados = ref("Data(Mais recente primeiro)");
var ordenacaoDeclaracoes = ref("Data(Mais recente primeiro)");

const anoCertificados = reactive([]);
const acaoCertificados = reactive([]);
const anoDeclaracoes = reactive([]);
const acaoDeclaracoes = reactive([]);

const declaracoes = ref([]);

const breadcrumbItems = computed(() => {
  return [
    { label: "Início", to: "/" },
    {
      label: "Certificados e Declarações",
      to: "/meus-Certificados-e-Declaracoes",
    },
  ];
});

onMounted(async () => {
  //inicia os filtros de certificados e declarações
  carregarFiltros("Certificados");
  await carregarDeclaracoesDoZip();
});

async function carregarDeclaracoesDoZip() {
  const [zipBytes, metadata] = await Promise.all([
    certificadoService.listarCertificadosUsuarioLogado(),
    certificadoService
      .listarCertificadosMetadataUsuarioLogado()
      .catch(() => []),
  ]);

  if (!zipBytes) return;

  const normalize = (name) => {
    if (!name) return "";
    return name.toLowerCase().replace(/[^a-z0-9]/g, "");
  };

  try {
    const zip = await JSZip.loadAsync(zipBytes);
    const carregadas = [];

    for (const [filename, file] of Object.entries(zip.files)) {
      if (!file.dir) {
        // extract activity name from filename, e.g. certificado_Minha_Atividade.pdf -> Minha Atividade
        let activityName = filename
          .replace(/^certificado_/, "")
          .replace(/\.pdf$/, "")
          .replace(/_/g, " ");

        // Get the file content as blob so we can download it later
        const blob = await file.async("blob");

        const normalizedZipName = normalize(activityName);
        const matchDto = (metadata || []).find(
          (dto) => normalize(dto.atividadeNome) === normalizedZipName
        );

        let dataEmissaoStr;
        let dataEmissaoFormatada;
        if (matchDto && matchDto.dataEmissao) {
          const datePart = String(matchDto.dataEmissao).substring(0, 10);
          dataEmissaoStr = datePart;
          const [ano, mes, dia] = datePart.split("-");
          dataEmissaoFormatada = `${dia}/${mes}/${ano}`;
        } else {
          const fallbackDate = file.date || new Date();
          const year = fallbackDate.getFullYear();
          const month = String(fallbackDate.getMonth() + 1).padStart(2, "0");
          const day = String(fallbackDate.getDate()).padStart(2, "0");
          dataEmissaoStr = `${year}-${month}-${day}`;
          dataEmissaoFormatada = `${day}/${month}/${year}`;
        }

        carregadas.push({
          titulo: "Declaração de Participação",
          acao: activityName,
          dataEmissao: dataEmissaoStr,
          dataEmissaoFormatada: dataEmissaoFormatada,
          blob: blob,
          filename: filename,
        });
      }
    }

    declaracoes.value = carregadas;
    carregarFiltros("Declaracoes");
  } catch (error) {
    console.error("Erro ao processar arquivo ZIP de certificados:", error);
  }
}

function baixarArquivoCertificado(declaracao) {
  if (!declaracao.blob) return;
  const url = window.URL.createObjectURL(declaracao.blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", declaracao.filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

function carregarFiltros(sessao) {
  if (sessao === "Certificados") {
    Object.values(certificados).forEach((certificado) => {
      let dateObj = new Date(certificado.dataEmissao);
      let ano = isNaN(dateObj.getTime())
        ? ""
        : dateObj.getFullYear().toString();

      if (!acaoCertificados.includes(certificado.acao)) {
        acaoCertificados.push(certificado.acao);
      }
      if (ano && !anoCertificados.includes(ano)) {
        anoCertificados.push(ano);
      }
    });
  } else if (sessao === "Declaracoes") {
    acaoDeclaracoes.length = 0;
    anoDeclaracoes.length = 0;

    declaracoes.value.forEach((declaracao) => {
      let ano = declaracao.dataEmissao
        ? declaracao.dataEmissao.substring(0, 4)
        : "";

      if (!acaoDeclaracoes.includes(declaracao.acao)) {
        acaoDeclaracoes.push(declaracao.acao);
      }
      if (ano && !anoDeclaracoes.includes(ano)) {
        anoDeclaracoes.push(ano);
      }
    });
  }
}

const certificadosFiltrados = computed(() => {
  //aplicando os filtros selecionados
  let filtro = Object.values(certificados).filter((certificado) => {
    return (
      certificado.acao.includes(filtroCertificados.value) ||
      certificado.dataEmissao.substring(0, 4).includes(filtroCertificados.value)
    );
  });

  //aplicando ordenação selecionada
  return Object.values(filtro)
    .slice()
    .sort((a, b) => {
      if (ordenacaoCertificados.value === "Data(Mais recente primeiro)") {
        return new Date(b.dataEmissao) - new Date(a.dataEmissao);
      } else {
        return new Date(a.dataEmissao) - new Date(b.dataEmissao);
      }
    });
});

const declaracoesFiltradas = computed(() => {
  //aplicando os filtros selecionados
  let filtro = declaracoes.value.filter((declaracao) => {
    const ano = declaracao.dataEmissao
      ? declaracao.dataEmissao.substring(0, 4)
      : "";
    return (
      declaracao.acao
        .toLowerCase()
        .includes(filtroDeclaracoes.value.toLowerCase()) ||
      ano.includes(filtroDeclaracoes.value)
    );
  });

  //aplicando ordenação selecionada
  return filtro.slice().sort((a, b) => {
    if (ordenacaoDeclaracoes.value === "Data(Mais recente primeiro)") {
      return b.dataEmissao.localeCompare(a.dataEmissao);
    } else {
      return a.dataEmissao.localeCompare(b.dataEmissao);
    }
  });
});

const ordenacoes = [
  "Data(Mais recente primeiro)",
  "Data(Mais antigo primeiro)",
];

const certificados = reactive({
  certificado1: {
    titulo: "Certificado 1",
    acao: "Ação 1",
    dataEmissao: "2024-04-10",
  },
  certificado2: {
    titulo: "Certificado 2",
    acao: "Ação 2",
    dataEmissao: "2023-06-22",
  },
  certificado3: {
    titulo: "Certificado 3",
    acao: "Ação 1",
    dataEmissao: "2023-09-15",
  },
});
</script>
<style scoped>
.certificados-declaracoes-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px 40px 15px;
  font-family: var(--font-base);
}

.header-menu-secao {
  margin-bottom: 30px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 20px;
}

.titulo-pagina {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--roxo-escuro);
  margin-bottom: 8px;
}

.subtitulo-pagina {
  font-size: 0.95rem;
  color: #64748b;
  margin: 0;
}

/* Accordion sections */
.secao-documentos {
  margin-bottom: 24px;
  background: var(--branco);
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.botao-dropdown {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 18px 24px;
  background-color: var(--branco);
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: left;
}

.botao-dropdown:hover {
  background-color: #f8fafc;
}

.botao-dropdown-esquerda {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--roxo-escuro1);
}

.secao-icon {
  color: var(--roxo-claro);
  flex-shrink: 0;
}

.botao-dropdown h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
  color: var(--roxo-escuro);
}

.chevron-icon {
  color: #64748b;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.chevron-icon.rotated {
  transform: rotate(180deg);
}

.secao-conteudo {
  padding: 24px;
  border-top: 1px solid #e2e8f0;
  background-color: #ffffff;
}

/* Filters & Sorting Panel */
.ordenacao-e-filtros {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  background-color: #f8fafc;
  padding: 16px 20px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  margin-bottom: 24px;
}

.filtros {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.filtros-label,
.ordenacao-label {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
}

.filtros-botoes {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.btn-filtro-dropdown {
  background-color: var(--branco);
  border: 1px solid #cbd5e1;
  color: #334155;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.btn-filtro-dropdown:hover {
  background-color: #f1f5f9;
  border-color: #94a3b8;
}

.dropdown-menu {
  border-radius: 8px;
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  padding: 6px 0;
  max-height: 280px;
  overflow-y: auto;
}

.dropdown-item {
  width: 100%;
  background-color: transparent;
  border: none;
  text-align: left;
  padding: 8px 16px;
  font-size: 0.875rem;
  color: #334155;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.dropdown-item:hover {
  background-color: #f1f5f9;
  color: var(--roxo-escuro1);
}

.limpar-filtros {
  background: transparent;
  border: 1px dashed #cbd5e1;
  color: #64748b;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.limpar-filtros:hover {
  background: rgba(255, 14, 14, 0.05);
  color: var(--vermelho);
  border-color: var(--vermelho);
}

.filtro-ativo-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: rgba(119, 47, 162, 0.08);
  color: var(--roxo-claro);
  border: 1px solid rgba(119, 47, 162, 0.15);
  padding: 4px 10px;
  border-radius: 16px;
  font-size: 0.8rem;
  font-weight: 600;
}

.remover-filtro {
  cursor: pointer;
  font-size: 1.1rem;
  line-height: 1;
  color: var(--roxo-claro);
  opacity: 0.7;
  transition: opacity 0.15s ease;
}

.remover-filtro:hover {
  opacity: 1;
}

.ordenacoes {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Card Lists */
.lista-documentos {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card-documento {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--branco);
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px 20px;
  transition: all 0.25s ease;
}

.card-documento:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-color: var(--roxo-claro);
  transform: translateY(-1px);
}

.card-documento-esquerda {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.documento-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(119, 47, 162, 0.08);
  color: var(--roxo-claro);
  width: 44px;
  height: 44px;
  border-radius: 8px;
  margin-right: 16px;
  flex-shrink: 0;
}

.documento-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  text-align: left;
}

.documento-titulo {
  font-size: 1.05rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 4px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.documento-detalhes {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.documento-acao-tag {
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--roxo-claro);
  background-color: rgba(119, 47, 162, 0.06);
  padding: 2px 8px;
  border-radius: 4px;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.documento-divisor {
  color: #cbd5e1;
  font-size: 0.8rem;
}

.documento-data {
  font-size: 0.8rem;
  color: #64748b;
}

.card-documento-direita {
  margin-left: 16px;
  flex-shrink: 0;
}

.btn-download-documento {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid var(--roxo-claro);
  background-color: transparent;
  color: var(--roxo-claro);
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
}

.btn-download-documento:hover {
  background-color: var(--roxo-claro);
  color: var(--branco);
}

.icon-baixar {
  flex-shrink: 0;
}

/* Empty State */
.sem-documentos {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #64748b;
  background-color: #f8fafc;
  border-radius: 10px;
  border: 1px dashed #cbd5e1;
}

.sem-doc-icon {
  color: #94a3b8;
  margin-bottom: 12px;
}

.sem-documentos p {
  font-size: 0.95rem;
  margin: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .ordenacao-e-filtros {
    flex-direction: column;
    align-items: stretch;
  }

  .filtros {
    flex-direction: column;
    align-items: flex-start;
  }

  .filtros-botoes {
    width: 100%;
  }

  .btn-group {
    flex: 1;
  }

  .btn-filtro-dropdown {
    width: 100%;
    justify-content: space-between;
  }

  .ordenacoes {
    justify-content: space-between;
  }

  .card-documento {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .card-documento-direita {
    margin-left: 0;
    width: 100%;
  }

  .btn-download-documento {
    width: 100%;
    justify-content: center;
  }

  .documento-acao-tag {
    max-width: 180px;
  }
}
</style>
